/* Swan Valley Design – engraving live preview + logo upload (Craft theme). */
(function () {
  if (window.__svdEngraveInit) return;
  window.__svdEngraveInit = true;

  function findForm(root) {
    var id = root.getAttribute('data-form-id');
    var form = id ? document.getElementById(id) : null;
    if (!form) {
      var section = root.closest('section, .shopify-section, product-info') || document;
      form = section.querySelector('form[id^="product-form-"]:not([id*="installment"])') ||
        document.querySelector('product-form form[id^="product-form-"]');
    }
    return form;
  }

  function init(root) {
    if (root.__svdReady) return;
    root.__svdReady = true;
    var form = findForm(root);
    if (form) {
      root.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (!el.getAttribute('form') && !form.contains(el)) el.setAttribute('form', form.id);
      });
    }

    var surface = root.querySelector('[data-svd-surface]');
    var placeholder = root.querySelector('[data-svd-placeholder]');
    var fontSel = root.querySelector('[data-svd-font]');
    var lines = root.querySelectorAll('[data-svd-line]');
    var logoImg = root.querySelector('[data-svd-logo-preview]');

    function applyFont() {
      if (!surface || !fontSel) return;
      var opt = fontSel.options[fontSel.selectedIndex];
      var css = (opt && opt.getAttribute('data-css')) || 'inherit';
      surface.style.fontFamily = css;
      fontSel.style.fontFamily = css;
    }

    function render() {
      if (!surface) return;
      var any = false;
      lines.forEach(function (input) {
        var key = input.getAttribute('data-svd-line');
        var target = surface.querySelector('[data-svd-preview-for="' + key + '"]');
        if (target) target.textContent = input.value;
        if (input.value.trim()) any = true;
      });
      if (logoImg && !logoImg.hidden) any = true;
      if (placeholder) placeholder.hidden = any;
    }

    lines.forEach(function (i) { i.addEventListener('input', render); });
    if (fontSel) fontSel.addEventListener('change', applyFont);

    root.querySelectorAll('[data-svd-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-svd-finish]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (surface) surface.setAttribute('data-finish', btn.getAttribute('data-svd-finish'));
      });
    });

    /* Logo upload (same behaviour as Precision JPC Lineitems: properties[Logo] file + _Logo Filename) */
    var picker = root.querySelector('[data-svd-logo-picker]');
    if (picker) {
      var PROP = 'properties[Logo]';
      var fileInput = picker.querySelector('[data-svd-logo]');
      var btn = picker.querySelector('[data-svd-logo-btn]');
      var clear = picker.querySelector('[data-svd-logo-clear]');
      var existing = picker.querySelector('[data-svd-logo-existing]');
      var existingVal = picker.querySelector('[data-svd-logo-existing-value]');
      var fname = picker.querySelector('[data-svd-logo-filename]');
      var hint = picker.querySelector('[data-svd-logo-hint]');
      var status = picker.querySelector('[data-svd-logo-status]');
      var hasFile = function () { return fileInput.files && fileInput.files.length > 0; };
      var setPreview = function (file) {
        if (!logoImg) return;
        if (file && /^image\//.test(file.type)) {
          var r = new FileReader();
          r.onload = function (e) { logoImg.src = e.target.result; logoImg.hidden = false; render(); };
          r.readAsDataURL(file);
        } else { logoImg.hidden = true; logoImg.removeAttribute('src'); render(); }
      };
      var syncFile = function () {
        if (existing && existing.checked) return;
        if (hasFile()) {
          var f = fileInput.files[0];
          if (f.size > 20 * 1024 * 1024) { status.textContent = 'File is larger than 20MB, please choose a smaller file.'; fileInput.value = ''; return syncFile(); }
          fileInput.setAttribute('name', PROP);
          fname.value = f.name; fname.setAttribute('name', 'properties[_Logo Filename]'); fname.disabled = false;
          status.textContent = 'Logo: ' + f.name;
          clear.hidden = false; if (hint) hint.hidden = true;
          setPreview(f);
        } else {
          fileInput.removeAttribute('name');
          fname.removeAttribute('name'); fname.disabled = true;
          status.textContent = ''; clear.hidden = true; if (hint) hint.hidden = false;
          setPreview(null);
        }
      };
      fileInput.removeAttribute('name');
      btn.addEventListener('click', function () { if (!fileInput.disabled) fileInput.click(); });
      fileInput.addEventListener('change', syncFile);
      clear.addEventListener('click', function () { fileInput.value = ''; syncFile(); });
      if (existing) existing.addEventListener('change', function () {
        if (existing.checked) {
          fileInput.removeAttribute('name'); fileInput.disabled = true; btn.disabled = true; clear.hidden = true;
          fname.removeAttribute('name'); fname.disabled = true;
          existingVal.setAttribute('name', PROP); existingVal.disabled = false;
          status.textContent = 'Using logo on file'; setPreview(null);
        } else {
          existingVal.removeAttribute('name'); existingVal.disabled = true;
          fileInput.disabled = false; btn.disabled = false; syncFile();
        }
      });
    }

    /* Required-field check before Craft's AJAX add-to-cart */
    var err = root.querySelector('[data-svd-error]');
    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form) return;
      var missing = [];
      root.querySelectorAll('[data-svd-required]').forEach(function (i) {
        if (!i.value.trim()) missing.push(i);
      });
      if (missing.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (err) { err.textContent = 'Please enter your Header / Main Text before adding to cart.'; err.hidden = false; }
        missing[0].focus();
      } else if (err) { err.hidden = true; }
    }, true);

    applyFont();
    render();
  }

  function boot() { document.querySelectorAll('[data-svd-engrave]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
